import { render, staticRenderFns } from "./TeamThree.vue?vue&type=template&id=5ac157e5"
import script from "./TeamThree.vue?vue&type=script&lang=js"
export * from "./TeamThree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports